import _ from "lodash";

function normalizeResponse(response: Response) {
  return response.json();
}

function httpRequest(method: string, url: string, params?: any) {
  const config: any = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic dGVzdDp0ZXN0",
    },
  };

  if (params) {
    config.body = JSON.stringify(params);
  }

  if (["POST", "DELETE", "PUT"].indexOf(method.toUpperCase()) !== -1) {
    config.headers["Content-Type"] = "application/json;charset=utf-8";
  }

  return fetch(url, config)
    .then(normalizeResponse)
    .catch((response) => {
      if (
        response.headers &&
        response.headers.get("Content-Type").indexOf("application/json") === 0
      ) {
        return response.json().then((r: any) => Promise.reject(r));
      }
      return Promise.reject(response);
    });
}

export default class API {
  static get(url: string) {
    return httpRequest("GET", url);
  }

  static put(url: string, params?: any) {
    return httpRequest("PUT", url, params);
  }

  static post(url: string, params?: any) {
    return httpRequest("POST", url, params);
  }

  static delete(url: string) {
    return httpRequest("DELETE", url);
  }

  static patch(url: string, params?: any) {
    return httpRequest("PATCH", url, params);
  }
}
